import "fs/promises";
const pastgameSummary = (v, i, l) => {
  const hg = v.goal_home ?? Object.values(v.goals ?? {}).filter((v2, i2, l2) => v2.team == "home").length;
  const ag = v.goal_away ?? Object.values(v.goals ?? {}).filter((v2, i2, l2) => v2.team == "away").length;
  delete v.events;
  delete v.fouls;
  delete v.injurys;
  delete v.corners;
  delete v.shots;
  delete v.offsides;
  delete v.yellowcards;
  delete v.home_lineup;
  delete v.away_lineup;
  delete v.home_substitutes;
  delete v.away_substitutes;
  return {
    ...v,
    hg,
    ag,
    winner: hg > ag ? "H" : hg == ag ? "D" : "A"
    // home:Object.values(v.goals).filter((v,i,l)=>v.team==),
    // scored: sc,
    // conceeded: cc,
    // result: sc > cc ? "W" : sc == cc ? "D" : "L",
    // matchid: v.id,
    // start: v.start,
  };
};
async function getForm(homeid, id, games) {
  var hometeamform = Object.values(games).filter(
    // fetchNew
    //   ? // Object.values({
    //     [
    //       // ...Object.values(JSON.parse(await readFile(games22Path, "utf8"))),
    //       ...
    (v, i, l) => (v.secondend != void 0 || v.patch_status == "finished") && // v.secondend &&
    !v.test && !(v.id.includes("test") || v.homeid.includes("test") || v.awayid.includes("test") || v.home.includes("test") || v.away.includes("test"))
  ).filter(
    (v, i, l) => v.id != id && // new Date(v.start).getTime() < new Date(data.start).getTime() &&
    (v?.homeid == homeid || v?.awayid == homeid)
    // ||
    // (v.homeid == data.awayid || v.awayid == data.awayid)
  ).map(pastgameSummary);
  hometeamform.sort(
    (b, a) => new Date(a.firststart ?? a.start).getTime() - new Date(b.firststart ?? b.start).getTime()
  );
  return hometeamform;
}
export {
  getForm as g,
  pastgameSummary as p
};
